// auth.js
export const FETCH_USER = 'FETCH_USER'
export const FETCH_USER_FAILURE = 'FETCH_USER_FAILURE'
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS'
export const FETCH_USER_PERMISSIONS = 'FETCH_USER_PERMISSIONS'
export const FETCH_USER_PERMISSIONS_FAILURE = 'FETCH_USER_PERMISSIONS_FAILURE'
export const FETCH_USER_PERMISSIONS_SUCCESS = 'FETCH_USER_PERMISSIONS_SUCCESS'
export const LOGOUT = 'LOGOUT'
export const SAVE_TOKEN = 'SAVE_TOKEN'
export const UPDATE_USER = 'UPDATE_USER'

// users.js
export const DELETE_USERS = 'DELETE_USERS'
export const FETCH_USERS = 'FETCH_USERS'
export const FETCH_USERS_FAILURE = 'FETCH_USERS_FAILURE'
export const FETCH_USERS_SUCCESS = 'FETCH_USERS_SUCCESS'

// evaluations.js
export const FETCH_EVALUATIONS_FAILURE = 'FETCH_EVALUATIONS_FAILURE'
export const FETCH_EVALUATIONS_SUCCESS = 'FETCH_EVALUATIONS_SUCCESS'
// isco.js
export const FETCH_ISCO_FAILURE = 'FETCH_ISCO_FAILURE'
export const FETCH_ISCO_SUCCESS = 'FETCH_ISCO_SUCCESS'

// organizations.js
export const DELETE_ORGANIZATIONS_SUCCESS = 'DELETE_ORGANIZATIONS_SUCCESS'
export const DELETE_ORGANIZATIONS_FAILURE = 'DELETE_ORGANIZATIONS_FAILURE'
export const FETCH_ORGANIZATIONS_FAILURE = 'FETCH_ORGANIZATIONS_FAILURE'
export const FETCH_ORGANIZATIONS_SUCCESS = 'FETCH_ORGANIZATIONS_SUCCESS'

// languages.js
export const FETCH_LANGUAGES_FAILURE = 'FETCH_LANGUAGES_FAILURE'
export const FETCH_LANGUAGES_SUCCESS = 'FETCH_LANGUAGES_SUCCESS'

// nationalities.js
export const FETCH_NATIONALITIES_FAILURE = 'FETCH_NATIONALITIES_FAILURE'
export const FETCH_NATIONALITIES_SUCCESS = 'FETCH_NATIONALITIES_SUCCESS'

// roles.js
export const FETCH_ROLES_FAILURE = 'FETCH_ROLES_FAILURE'
export const FETCH_ROLES_SUCCESS = 'FETCH_ROLES_SUCCESS'

// lang.js
export const SET_LOCALE = 'SET_LOCALE'



// WEBPACK FOOTER //
// ./resources/js/store/mutation-types.js